import React from 'react';
import PropTypes from 'prop-types';

export default function Title({ children, subText, isSubPageTitle }) {
    return (
        <div className="title__container">
            <h2
                className={`title__main-text${
                    isSubPageTitle ? '--sub-page' : ''
                }`}
            >
                {children}
            </h2>
            {subText && <p className="title__sub-text">{subText}</p>}
        </div>
    );
}

Title.propTypes = {
    children: PropTypes.string,
    /* Sub title description */
    subText: PropTypes.string,
};
